// @ts-check
import { createCrudProp } from '../utils/crud-prop'
import { removeKeysWithNullishValues } from '../utils/object'
import { createSelector } from '../utils/selector-utils'
import { sortByTimeIfExists } from '../utils/sort-by'
import { selectVitalsCheckpointsRaw } from './checkpoints'

const eventProps = createCrudProp({
  rootKey: 'customEvents',
  idPrefix: 'ev',
  requiredProps: ['time', 'note'],
  sortFn: sortByTimeIfExists,
})

/**
 * @param {{
 *   note: string
 *   time: number
 *   checkpointId?: string
 * }} updates
 * @returns {any} Updates to apply to the case
 */
export const actionAddCustomEvent = ({ note, time, checkpointId }) =>
  eventProps.actionAdd(
    removeKeysWithNullishValues({ note, time, checkpointId })
  )

/**
 * @param {string} id
 * @param {{ note?: string; time?: number }} updates
 * @returns {any} Updates to apply to the case
 */
export const actionUpdateCustomEvent = eventProps.actionUpdate

/**
 * @param {string} id
 * @returns {any} Updates to apply to the case
 */
export const actionRemoveCustomEvent = eventProps.actionRemove

/** @type {CaseSelector<(CustomCaseEventRaw & { id: string })[]>} */
export const selectCustomEventsAsArray = createSelector(
  eventProps.select,
  selectVitalsCheckpointsRaw,
  (customEvents, checkpointsRaw) =>
    customEvents.map(event => {
      const { checkpointId, time } = event
      let timeToUse = time || null
      // if this is a checkpoint note, and we have a checkpoint with a time
      // we should use the checkpoint time.
      // (previously we allowed for checkpoint-tied events to not record a time)
      if (checkpointId) {
        const correspondingCheckpoint = checkpointsRaw[checkpointId]
        if (correspondingCheckpoint && correspondingCheckpoint.time) {
          timeToUse = correspondingCheckpoint.time
        }
      }
      return {
        ...event,
        time: timeToUse,
      }
    })
)

/** @type {CaseSelector<Record<string, number>>} */
export const selectCustomEventTimesByEventId = createSelector(
  selectCustomEventsAsArray,
  events => {
    /** @type {Record<string, number>} */
    const toReturn = {}
    for (const event of events) {
      toReturn[event.id] = event.time
    }
    return toReturn
  }
)
